import { CancelCompleteStep } from "@/features/reservation/components/CancelCompleteStep";

/**
 * 予約キャンセル完了画面 (/reservations/:reservationToken/cancel/complete)。予約アクセストークンは
 * ReservationTokenLayout が interceptor へ渡すため、本画面はパラメータを受け取らず GetReservation で
 * キャンセル済みの予約内容を表示する。
 */
export default function CancelCompletePage() {
  return <CancelCompleteStep />;
}
